/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForPeriodicCloudOpsInsight extends models.PeriodicBackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForPeriodicCloudOpsInsight");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForPeriodicCloudOpsInsight.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForPeriodicCloudOpsInsight>): BackgroundJobPayloadForPeriodicCloudOpsInsight {
        let obj = Object.assign(new BackgroundJobPayloadForPeriodicCloudOpsInsight(), model);
        BackgroundJobPayloadForPeriodicCloudOpsInsight.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForPeriodicCloudOpsInsight>): BackgroundJobPayloadForPeriodicCloudOpsInsight {
        if (!model) return null;
        return BackgroundJobPayloadForPeriodicCloudOpsInsight.newInstance(<BackgroundJobPayloadForPeriodicCloudOpsInsight> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForPeriodicCloudOpsInsight) {
        if (!obj) return;

        models.BackgroundJobPayloadForPeriodicCloudOpsInsight.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForPeriodicCloudOpsInsight): boolean {
        if (models.PeriodicBackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForPeriodicCloudOpsInsight.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
